<template>
  <transition name="modal">
    <div v-if="isVisible" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-content">
          <!-- 双上传框：图片 + 音乐 -->
          <div class="modal-row upload-row">
            <!-- 图片上传 -->
            <div class="upload-item">
              <label>封面图片</label>
              <el-upload
                class="img-uploader"
                action="#"
                :show-file-list="false"
                :before-upload="beforeImgUpload"
                :http-request="handleImgUpload"
              >
                <img v-if="localMusicInfo.imgUrl" :src="localMusicInfo.imgUrl" class="preview-img">
                <i v-else class="el-icon-plus uploader-icon"></i>
              </el-upload>
            </div>

            <!-- 音乐上传 -->
            <div class="upload-item">
              <label>音乐文件</label>
              <el-upload
                class="music-uploader"
                action="#"
                :show-file-list="false"
                :before-upload="beforeMusicUpload"
                :http-request="handleMusicUpload"
              >
                <div v-if="localMusicInfo.musicFileName" class="music-file-name">
                  {{ localMusicInfo.musicFileName }}
                </div>
                <i v-else class="el-icon-plus uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          
          <div class="modal-row two-columns">
            <div class="column">
              <label>曲名</label>
            </div>
            <div class="column">
              <el-input 
                v-model="localMusicInfo.title" 
                placeholder="请输入音乐名称"
              ></el-input>
            </div>
          </div>

          <div class="modal-row two-columns">
            <div class="column">
              <label>作者</label>
            </div>
            <div class="column">
              <el-input 
                v-model="localMusicInfo.artist" 
                placeholder="请输入音乐作者"
              ></el-input>
            </div>
          </div>

          <div class="modal-row two-columns">
            <div class="column">
              <label>状态管理</label>
            </div>
            <div class="column">
              <select v-model="localMusicInfo.status" class="status-select">
                <option value="0">正常</option>
                <option value="1">禁用</option>
              </select>
            </div>
          </div>
          
          <div class="modal-row button-row">
            <el-button @click="closeModal">关闭窗口</el-button>
            <el-button @click="clearForm">清空数据</el-button>
            <el-button type="primary" @click="submitForm">提交数据</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Message } from 'element-ui';
import { saveMusic } from '@/api/music';

export default {
  name: 'CreateMusic',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    MusicInfo: {
      type: Object,
      default: () => ({
        id: null,
        title: '',
        artist: '',
        status: '0',
        imgUrl: '',
        url: '',
      })
    },
  },
  data() {
    return {
      localMusicInfo: {
        ...this.MusicInfo,
        imgUrl: '',
        url: '',
        musicFile: null,
        imgFile: null,
        musicFileName: ''
      },
    }
  },
  methods: {
    clearForm() {
      this.localMusicInfo = {
        id: null,
        title: '',
        artist: '',
        status: '0',
        imgUrl: '',
        url: '',
        musicFile: null,
        imgFile: null,
        musicFileName: ''
      }
    },
    closeModal() {
      this.clearForm();
      this.$emit('update:visible', false);
    },

    // ==================== 图片上传校验 ====================
    beforeImgUpload(file) {
      const isImage = file.type.includes('image/');
      if (!isImage) {
        Message.error('只能上传图片文件!');
      }
      return isImage;
    },
    handleImgUpload({ file }) {
      this.localMusicInfo.imgFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.localMusicInfo.imgUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    // ==================== 音乐上传校验 ====================
    beforeMusicUpload(file) {
      const isMusic = file.type.includes('audio/');
      if (!isMusic) {
        Message.error('只能上传音频文件!');
      }
      return isMusic;
    },
    handleMusicUpload({ file }) {
      this.localMusicInfo.musicFile = file;
      this.localMusicInfo.musicFileName = file.name;
    },

    // ==================== 提交 ====================
    async submitForm() {
      if (!this.localMusicInfo.title) { Message.error('请填写曲名'); return; }
      if (!this.localMusicInfo.artist) { Message.error('请填写作者'); return; }
      if (!this.localMusicInfo.imgFile) { Message.error('请上传封面图片'); return; }
      if (!this.localMusicInfo.musicFile) { Message.error('请上传音乐文件'); return; }

      const formData = new FormData();
      const musicInfo = {
        id: this.localMusicInfo.id,
        title: this.localMusicInfo.title,
        artist: this.localMusicInfo.artist,
        status: this.localMusicInfo.status
      };
      
      // 后端参数：descInfo + musicFile + imgFile
      formData.append('descInfo', JSON.stringify(musicInfo));
      formData.append('musicFile', this.localMusicInfo.musicFile);
      formData.append('imgFile', this.localMusicInfo.imgFile);

      try {
        const resp = await saveMusic(formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (resp.code === 200 && resp.success) {
          Message.success('保存成功！');
          this.$emit('saved', resp.data);
          this.closeModal();
        } else {
          Message.error(resp.msg || '保存失败');
        }
      } catch (error) {
        Message.error('请求失败');
      }
    }
  }
}
</script>

<style scoped>
@media(max-width: 768px){
  .modal-container { width: 90% !important; padding: 6px !important; }
  .upload-row { flex-direction: column; gap: 20px; align-items: center; }
}
.modal-mask {
  position: fixed; z-index: 1000; top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex; justify-content: center; align-items: center;
  transition: opacity 0.3s ease;
}
.modal-container {
  width: 50%; min-height: 60%;
  background-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex; flex-direction: column; padding: 20px;
}
.modal-content { display: flex; flex-direction: column; height: 100%; }
.modal-row { margin-bottom: 20px; }
.upload-row {
  display: flex; gap: 40px;
  justify-content: center; margin-bottom: 24px;
}
.upload-item { display: flex; flex-direction: column; align-items: center; gap: 8px; }
.two-columns { display: flex; align-items: center; }
.column { flex: 1; }
.column:first-child { margin-right: 15px; min-width: 100px; }
.status-select { width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; }
.button-row {
  display: flex; justify-content: flex-end; margin-top: auto;
  padding-top: 15px; border-top: 1px solid #eee;
}
.button-row button { margin-left: 10px; }

.img-uploader, .music-uploader {
  border: 1px dashed #d9d9d9; border-radius: 6px;
  cursor: pointer; position: relative; overflow: hidden;
  width: 178px; height: 178px;
}
.img-uploader:hover, .music-uploader:hover { border-color: #409EFF; }
.uploader-icon {
  font-size: 28px; color: #8c939d;
  width: 178px; height: 178px; line-height: 178px; text-align: center;
}
.preview-img { width: 178px; height: 178px; display: block; object-fit: cover; }
.music-file-name {
  width: 100%; height: 100%; display: flex;
  align-items: center; justify-content: center;
  word-break: break-all; padding: 10px; box-sizing: border-box;
}

/* 过渡动画 */
.modal-enter-from, .modal-leave-to { opacity: 0; }
.modal-enter-from .modal-container, .modal-leave-to .modal-container { transform: scale(0.9); }
</style>